// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3FCuK","checkboxCol":"Table_checkboxCol__1Th2b","emailCol":"Table_emailCol__25FqM","actionCol":"Table_actionCol__2XxDI"};